import React from 'react';
import { Badge, Button, Flex, Group, Stack, Text } from '@mantine/core';
import { IconRefresh, IconServerBolt } from '@tabler/icons-react';

import { MaintenanceTabPanelHeader } from '../common/MaintenanceTabPanelHeader';
import { When } from '../common';
import type { PriceSyncQueueStats } from './priceSync.types';

type PriceSyncMonitorHeaderProps = {
    stats: PriceSyncQueueStats | undefined;
    refreshLoading: boolean;
    triggerLoading: boolean;
    onRefresh: () => void;
    onTriggerSync: () => void;
};

export function PriceSyncMonitorHeader({
    stats,
    refreshLoading,
    triggerLoading,
    onRefresh,
    onTriggerSync,
}: PriceSyncMonitorHeaderProps) {
    return (
        <MaintenanceTabPanelHeader>
            <div className="flex flex-wrap items-start justify-between gap-4">
                <Stack gap="xs">
                    <Group gap="xs">
                        <IconServerBolt size={22} />
                        <Text size="lg" fw={500}>
                            LetsCreate Price Sync
                        </Text>
                        <When condition={Boolean(stats)}>
                            <Badge
                                size="sm"
                                variant="light"
                                color={
                                    stats?.integrationEnabled ? 'green' : 'gray'
                                }
                            >
                                {stats?.integrationEnabled
                                    ? 'Integration enabled'
                                    : 'Integration disabled'}
                            </Badge>
                        </When>
                    </Group>
                    <Text size="sm" c="dimmed">
                        Monitor and action the future-dated prices sync queue.
                        Stats auto-refresh every 30 seconds.
                    </Text>
                </Stack>
                <Flex gap="xs" wrap="nowrap">
                    <Button
                        variant="light"
                        size="xs"
                        leftSection={<IconRefresh size={14} />}
                        onClick={onRefresh}
                        loading={refreshLoading}
                        fullWidth={false}
                        w="150px"
                    >
                        Refresh
                    </Button>
                    <Button
                        variant="filled"
                        size="xs"
                        leftSection={<IconServerBolt size={14} />}
                        onClick={onTriggerSync}
                        loading={triggerLoading}
                        fullWidth={false}
                        w="150px"
                    >
                        Run sync now
                    </Button>
                </Flex>
            </div>
        </MaintenanceTabPanelHeader>
    );
}
